import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame, Users, MessageSquare } from "lucide-react";

export default function TrendingRail() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/rooms/trending?limit=5");
        if (alive) setRooms(data);
      } catch {
        /* silent */
      }
    };
    load();
    const t = setInterval(load, 8000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const anyHeat = rooms.some((r) => r.heat > 0);
  if (rooms.length === 0) return null;

  return (
    <section className="border-b border-white/10 bg-obsidian" data-testid="trending-rail">
      <div className="px-4 md:px-8 py-5 max-w-[1400px] mx-auto">
        <div className="flex items-center gap-2 mb-3">
          <Flame className="w-4 h-4 text-blaze animate-pulse" />
          <span className="font-mono text-[10px] tracking-[0.3em] text-blaze uppercase">Hot right now</span>
          {!anyHeat && (
            <span className="font-mono text-[10px] tracking-widest text-white/30 uppercase ml-2">
              // it&apos;s quiet · be the spark
            </span>
          )}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-0 border-l border-t border-white/10">
          {rooms.map((r, idx) => (
            <Link
              key={r.slug}
              to={`/room/${r.slug}`}
              data-testid={`trending-${r.slug}`}
              className="group relative border-r border-b border-white/10 p-4 hover:bg-panel"
            >
              <div className="flex items-center gap-2 font-mono text-[10px] tracking-widest" style={{ color: r.color }}>
                <span className="text-blaze">#{idx + 1}</span>
                <span>{r.preset ? "PRESET" : `@${r.created_by}`}</span>
              </div>
              <h3 className="font-heading text-2xl md:text-3xl leading-none mt-2 group-hover:text-acid transition-colors">
                {r.name}
              </h3>
              <div className="flex items-center gap-3 mt-3 font-mono text-[11px] text-white/60">
                <span className="flex items-center gap-1">
                  <div className={`w-1.5 h-1.5 ${r.live_count > 0 ? "bg-acid animate-pulse" : "bg-white/20"}`} />
                  <Users className="w-3 h-3" /> {r.live_count}
                </span>
                <span className="flex items-center gap-1">
                  <MessageSquare className="w-3 h-3" /> {r.recent_count}<span className="text-white/30">/hr</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
